import { makeStyles, Theme } from '@material-ui/core'

export const useKanbanCardStyles = makeStyles((theme: Theme) => ({
  root: {
    // backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
    width: '250px',
    height: '194px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  ['priority-0']: {
    backgroundColor: 'inherit',
    color: theme.palette.text.primary,
  },
  ['priority-1']: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  ['priority-2']: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  ['priority-3']: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
  ['priority-4']: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.success.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    },
  },
  valueLabelRoot: {
    display: 'flex',
    alignItems: 'space-around',
    gap: theme.spacing(2),
  },
  label: {
    // display: 'inline-block',
    flex: '0 0 40%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  value: {
    // display: 'inline-block',
    flex: '0 0 60%',
    paddingRight: theme.spacing(2),
  },
  header: {
    padding: theme.spacing(1, 1, 1, 2),
    cursor: 'grab',

    '& .MuiCardHeader-content': {
      overflow: 'hidden',

      '& .MuiTypography-displayBlock': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
    },
  },
  headerMenu: {
    marginTop: theme.spacing(0.5),
    color: 'inherit',
  },
  content: {
    padding: `${theme.spacing(1, 2, 1, 2)} !important`,
    '& hr': {
      margin: '4px -16px !important',
    },
    cursor: 'pointer',
  },
  rightAligned: {
    textAlign: 'right',
  },
}))
